import { Autocomplete, TextField } from "@mui/material";
import CiscoAvatar from "components/app/CiscoAvatar";
import { ChangeEvent, FC, useRef, useState } from "react";
import { ControllerFieldState, ControllerRenderProps } from "react-hook-form/dist/types/controller";
import { useAssigneeList } from "../hooks";

export interface AssigneeOption {
  name: string;
  cecId: string;
  role?: string;
}

const Assignee: FC<{
  field: ControllerRenderProps;
  fieldState: ControllerFieldState;
}> = ({ fieldState, field }) => {
  const [keyword, setKeyword] = useState("");
  const [inputValue, setInputValue] = useState("");
  const debounceTimer = useRef<NodeJS.Timeout | null>(null);
  const { data: assigneeList, mutate, isValidating } = useAssigneeList(keyword);
  const [assignee, setAssignee] = useState<AssigneeOption>(
    field.value ? field.value : assigneeList?.[0]
  );

  const handleInput = (e: ChangeEvent<HTMLInputElement>) => {
    // only when user input str >=3 to call && trigger query within 300ms
    const val = e.target.value.trim();
    setInputValue(val);

    if (debounceTimer.current) {
      clearTimeout(debounceTimer.current);
    }
    debounceTimer.current = setTimeout(() => {
      if (val.length >= 3) {
        setKeyword(val);
        mutate();
      } else {
        setKeyword("");
      }
    }, 300);
  };

  return (
    <div>
      <p
        style={{
          fontSize: 12,
        }}
      >
        Assignee To
      </p>

      <Autocomplete
        {...field}
        autoFocus
        disableClearable
        getOptionLabel={(option) => option?.name ?? ""}
        loading={isValidating}
        noOptionsText={"No assignee found"}
        isOptionEqualToValue={(o, v) => o.cecId === v.cecId}
        options={assigneeList || []}
        filterOptions={(x) => x}
        renderOption={(props, option) => (
          <li {...props}>
            <div style={{ display: "flex", alignItems: "center" }}>
              <CiscoAvatar
                username={option.cecId}
                style={{ width: 24, height: 24, marginRight: 12 }}
              />
              <div>
                <p style={{ lineHeight: 1.2 }}>{option.name}</p>
                <p style={{ color: "#777777", lineHeight: 1.2 }}>{option.role}</p>
              </div>
            </div>
          </li>
        )}
        renderInput={(params) => (
          <TextField
            {...params}
            margin="normal"
            variant="outlined"
            InputProps={{
              ...params.InputProps,
              type: "search",
              style: {
                height: 40,
                borderRadius: 8,
              },
            }}
            sx={{ marginTop: 0 }}
            error={!!fieldState.error}
            helperText={fieldState.error?.message}
            size={"small"}
            placeholder={"Please select or search"}
            value={inputValue}
            onChange={handleInput}
          />
        )}
        value={assignee}
        onChange={(_e: any, value) => {
          setAssignee(value as AssigneeOption);
          field.onChange(value);
        }}
      />
    </div>
  );
};

export default Assignee;
